import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
// const API_URL = "https://192.168.1.11:3000/api/admin";
//const API_URL = 'https://testapi.apnamandal.com/api'
//const API_URL = 'http://192.168.1.211:3000/api/admin'

const LOADING_EVENT = 'api-loading-state'

const setLoading = isLoading => {
	window.dispatchEvent(new CustomEvent(LOADING_EVENT, { detail: { isLoading } }))
}

axios.interceptors.request.use(
	config => {
		if (config.loading !== false) {
			setLoading(true)
		}
		return config
	},
	error => {
		setLoading(false)
		return Promise.reject(error)
	},
)

axios.interceptors.response.use(
	response => {
		if (response.config.loading !== false) {
			setLoading(false)
		}
		return response
	},
	error => {
		if (error.config?.loading !== false) {
			setLoading(false)
		}
		return Promise.reject(error)
	},
)

class HttpService {
	get(url, params = {}, customHeaders = {}, config = {}) {
		return call('GET', url, params, {}, customHeaders, config)
	}

	post(url, params = {}, payload = {}, customHeaders = {}, config = {}) {
		return call('POST', url, params, payload, customHeaders, config)
	}

	delete(url, params = {}, payload = {}, customHeaders = {}, config = {}) {
		return call('DELETE', url, params, payload, customHeaders, config)
	}

	put(url, params = {}, payload = {}, customHeaders = {}, config = {}) {
		return call('PUT', url, params, payload, customHeaders, config)
	}
}

function call(method, URL, params, payload = {}, customHeaders = {}, config = {}) {
	const defaultHeaders = {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${localStorage.getItem('token')}`,
	}

	const opts = {
		method,
		url: API_URL + URL,
		headers: {
			...defaultHeaders,
			...customHeaders,
		},
		params,
		data: payload,

		loading: config.loading !== false,
	}

	return axios(opts)
}

export default new HttpService()
